module.exports = __webpack_public_path__ + "static/media/index.d41d8cd9.scss";


//////////////////
// WEBPACK FOOTER
// ./src/views/exchange-rate/index.scss
// module id = 160
// module chunks = 0